// Generated by Ktorfit
@file:Suppress("warnings")

package org.mifospay.core.network.services

import de.jensklingenberg.ktorfit.Ktorfit
import de.jensklingenberg.ktorfit.`internal`.ClassProvider
import de.jensklingenberg.ktorfit.`internal`.InternalKtorfitApi
import de.jensklingenberg.ktorfit.`internal`.KtorfitConverterHelper
import io.ktor.client.HttpClient
import io.ktor.client.request.HttpRequestBuilder
import io.ktor.client.request.setBody
import io.ktor.http.HttpMethod
import io.ktor.http.encodeURLPath
import io.ktor.http.takeFrom
import io.ktor.util.reflect.typeInfo
import kotlin.Int
import kotlin.Long
import kotlin.OptIn
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlin.collections.Map
import kotlinx.coroutines.flow.Flow
import org.mifospay.core.network.model.CommonResponse
import org.mifospay.core.network.model.GenericResponse
import org.mifospay.core.network.model.entity.UserWithRole
import org.mifospay.core.network.model.entity.user.NewUserEntity
import org.mifospay.core.network.model.entity.user.UpdateUserEntityPassword
import org.mifospay.core.network.model.entity.user.UpdateUserPasswordResponse

@OptIn(InternalKtorfitApi::class)
public class _UserServiceImpl(
  private val _baseUrl: String,
  private val _httpClient: HttpClient,
  private val _helper: KtorfitConverterHelper,
) : UserService {
  override suspend fun users(): Flow<List<UserWithRole>> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "users")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<List<UserWithRole>>>(),)!! 
  }

  override suspend fun createUser(user: NewUserEntity): CommonResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("POST")
        url{
        takeFrom(_baseUrl + "users")
        }
        setBody(user) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<CommonResponse>(),)!! 
  }

  override suspend fun updateUser(userId: Int, updateUserEntity: NewUserEntity): Flow<GenericResponse> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "users/${"$userId".encodeURLPath()}")
        }
        setBody(updateUserEntity) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<GenericResponse>>(),)!! 
  }

  override suspend fun updateUserPassword(userId: Long, updateUserEntity: UpdateUserEntityPassword): UpdateUserPasswordResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "users/${"$userId".encodeURLPath()}")
        }
        setBody(updateUserEntity) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<UpdateUserPasswordResponse>(),)!! 
  }

  override suspend fun deleteUser(userId: Int): CommonResponse {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("DELETE")
        url{
        takeFrom(_baseUrl + "users/${"$userId".encodeURLPath()}")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<CommonResponse>(),)!! 
  }

  override suspend fun getUser(): Flow<UserWithRole> {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("GET")
        url{
        takeFrom(_baseUrl + "self/userdetails")
        } 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Flow<UserWithRole>>(),)!! 
  }

  override suspend fun assignClientToUser(userId: Int, clients: Map<String, List<Int>>) {
    val _ext: HttpRequestBuilder.() -> Unit = {
        this.method = HttpMethod.parse("PUT")
        url{
        takeFrom(_baseUrl + "users/${"$userId".encodeURLPath()}")
        }
        setBody(clients) 
        }
    return _helper.suspendRequest(_httpClient, _ext, typeInfo<Unit>(),)!! 
  }
}

public class _UserServiceProvider : ClassProvider<UserService> {
  override fun create(_ktorfit: Ktorfit): UserService = _UserServiceImpl(_ktorfit.baseUrl, _ktorfit.httpClient, KtorfitConverterHelper(_ktorfit))
}

public fun Ktorfit.createUserService(): UserService = _UserServiceImpl(this.baseUrl, this.httpClient, KtorfitConverterHelper(this))
